<template>
    <component
        :is="editorComponent"
    />
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "TestEditor",
    data() {
        return {
            editSessionMaintainInterval: null,
        };
    },
    computed: {
        ...mapGetters('tests', [
            'editorComponent',
            'testEditor',
            'sessionMaintainInterval',
        ]),
    },
    methods: {
        ...mapActions('tests', [
            'editSessionMaintain',
            'editSessionDestroy',
        ]),
    },
    created() {
        this.editSessionMaintainInterval = setInterval(() => {this.editSessionMaintain(this.testEditor.test)}, this.sessionMaintainInterval * 1000);
    },
    beforeDestroy() {
        clearInterval(this.editSessionMaintainInterval);
        this.editSessionDestroy(this.testEditor.test);
    }
}
</script>